import { Injectable } from '@angular/core';
import { BrandCreate, BrandEntity, BrandUpdate } from '@models';
import { BaseApi } from './_base-api';
import { APIHelper } from '@controladad/ng-base';

@Injectable({
  providedIn: 'root',
})
export class BrandApiService extends BaseApi<BrandEntity, BrandCreate, BrandUpdate> {
  constructor() {
    super('/AdminPanel/Brand', {
      get: '/AdminPanel/GetBrandList',
      post: '/AdminPanel/AddBrand',
    });
  }

  // @ts-ignore
  override update(data: BrandUpdate) {
    return http$.put('/AdminPanel/EditBrand', { brandId: data.brandId, fields: APIHelper.nestValues(data.fields) });
  }

  // @ts-ignore
  override delete(id: number) {
    return http$.delete('/AdminPanel/DeleteBrand', { body: { brandId: id } });
  }

  getBrandItems() {
    return super.getItemRecords((item) => ({ label: item.name.english, value: item.id }));
  }
}
